export var chatVariables = function chatVariables(siteVars) {
  return {
    backgroundColor: siteVars.colorScheme.default.background2
  };
};